@if (!state.error) {
    @if (useLoader && (state.loading || isLoading)) {
        <div class="loading-v3" data-crlat="flashing.loader"><div class="dot-flashing"></div></div>
    }
    <div [ngClass]="{ container: !removeContainer }" [innerHtml]="innerHtml"></div>
} @else if (!state.loading) {
    <request-error (reloadFn)="reloadComponent()"></request-error>
}
